import { Spinner } from "@/components/ui/custom/spinner"

export function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-2">
        <Spinner variant="default" size={48} />
        <span className="text-lg text-muted-foreground">Loading</span>
      </div>
    </div>
  )
}
